import { useFlags } from 'launchdarkly-react-client-sdk'
import { useIsLDReadyForUser } from 'mednet-cns/src/hooks/launchDarkly'

// Standalone function - can be used anywhere by passing the flag value
export function getTopicPath(topicId, enableV2FeedPage, params = null) {
  const queryString = params ? `?${new URLSearchParams(params).toString()}` : ''
  if (enableV2FeedPage) {
    return `/v2/topic/${topicId}/questions${queryString}`
  }
  return `/topic/${topicId}${queryString}`
}

// Hook - for use in React components
export default function useTopicPath() {
  const isLdReady = useIsLDReadyForUser()
  const { enableV2FeedPage } = useFlags()

  return {
    getTopicPath: (topicId, params) =>
      getTopicPath(topicId, enableV2FeedPage, params),
    isLdReady,
  }
}
